export enum TravelerTypeOptions {
  BUSINESS = 'business_travelers',
  FAMILY = 'families'
}

export enum ReviewsFilterTypes {
  TRAVELER_TYPE = 'travelerType'
}
